import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { addTokenRefreshedListener } from "api/instancePromotion";

/**
 * axiosInstancePromotion의 인터셉터에서 토큰이 자동으로 갱신되었을 때
 * Recoil 상태(userSimpleAtom)의 accessToken을 동기화해주는 훅
 */
export default function useSyncPromotionToken() {
  const setUser = useSetRecoilState(userSimpleAtom);

  useEffect(() => {
    const removeListener = addTokenRefreshedListener((newAccessToken) => {
      setUser((prev) => {
        if (!prev) return { accessToken: newAccessToken };
        if (prev.accessToken === newAccessToken) return prev;
        return { ...prev, accessToken: newAccessToken };
      });
    });

    return () => removeListener();
  }, [setUser]);
}
